import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FilterService } from 'libs/portal/src/services/filter/filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-device-status-filter',
  templateUrl: './device-status-filter.component.html',
  styleUrls: ['./device-status-filter.component.scss'],
})
export class DeviceStatusFilterComponent implements OnInit, OnDestroy {
  @Output() statusToggleEvent = new EventEmitter<boolean>();
  defaultSelectedRadio = 'online';
  selectedRadioGroup: any;
  selectedRadioItem: any;
  status: string;
  sub: Subscription;

  radio_list = [
    {
      id: '1',
      name: 'radio_list',
      value: 'online',
      text: 'Online',
      disabled: false,
      color: 'primary',
    },
    {
      id: '2',
      name: 'radio_list',
      value: 'offline',
      text: 'Offline',
      disabled: false,
      color: 'primary',
    },
  ];

  constructor(private filterService: FilterService) {}

  radioGroupChange(event) {
    this.status = event.detail.value;
  }

  filter() {
    const filterObj = {
      status: this.status,
    };
    this.filterService.emit(filterObj);
  }

  ngOnInit() {
   this.sub = this.filterService.searchClickedEvent.subscribe((clicked) => {
      if (clicked) {
        this.filter();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  radioFocus() {
    // console.log("radioFocus");
  }

  radioSelect(event) {
    this.selectedRadioItem = event.detail;
  }

  radioBlur() {
    // console.log("radioBlur");
  }
}
